import { ConcreteEncodable } from "./ConcreteEncodable";

import { SavedOrderEventListImplEncoder } from "../../encoder/SavedOrderEventListImplEncoder";

import * as CubiqTS from "../../index";
import { SavedOrderEventList } from "../SavedOrderEventList";

export class SavedOrderEventListImpl extends ConcreteEncodable implements SavedOrderEventList {
  public static enType: string = "com.bcdfx.model.event.lifecycle.SavedOrderEventListImpl";

  /*FID=1*/
  public userCode: string;
  /*FID=2*/
  public uploadId: string;
  /*FID=3*/
  public orderDataRequests: Array<CubiqTS.LinkedOrderRequest> | null = null;
  /*FID=4*/
  public fixingOrderRequests: Array<CubiqTS.FixingOrderRequest> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SavedOrderEventListImplEncoder.Instance;
    this.setEncodableType(SavedOrderEventListImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SavedOrderEventListImpl[" +
      "userCode=" +
      this.userCode +
      "uploadId=" +
      this.uploadId +
      "orderDataRequests=" +
      this.orderDataRequests +
      "fixingOrderRequests=" +
      this.fixingOrderRequests +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
